import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ObservableBackendService} from "./observableBackend.service";
import {Bank} from "../domain/bank";
import {URLSearchParams} from "@angular/http";
import {Page} from "../domain/page";

@Injectable()
export class BankService {

    constructor(private backendService:ObservableBackendService) {
    }

    public getBanks():Observable<Bank[]> {
        return this.backendService.get("banks", null);
    }

    public getBanksNoAuth():Observable<Bank[]> {
        return this.backendService.get("banksNoAuth", null);
    }

    public findBanks(filter:string, page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        if (filter) {
            params.set('filter', filter);
        }

        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("findBanks", params);
    }

    public listBanks(page:number, itemsPerPage:number):Observable<Page> {
        let params = new URLSearchParams();
        params.set('length', String(itemsPerPage));
        params.set('pageNumber', String(page));
        return this.backendService.get("listBanks", params);
    }

    public getBank(bankId:string):Observable<Bank> {
        return this.backendService.get("bank/" + bankId, null);
    }

    public save(bank:Bank):Observable<Bank> {
        if (bank.id != null) {
            return this.backendService.post("bank", bank, null);
        } else {
            return this.backendService.put("bank", bank, null);
        }
    }

    public delete(bankId:string):Observable<Bank> {
        return this.backendService.delete("bank/" + bankId, null, null);
    }

    public generateBankTempId():Observable<any> {
        return this.backendService.get("bank/generateTempId", null);
    }

    public deleteTempBankDocument(bankId:string):Observable<boolean> {
        return this.backendService.delete("bank/" + bankId + "/documentTemp/", null, null);
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/service/bank.service.ts
 **/